import '../common/common.js'
import {MiniBasket} from "./MiniBasket.js";

window.o_global.eventQBus.onModuleLoaded(
    'ft1.order-core.minibasket',
    ['ft1.order-core.common-public'],
    () => {
      MiniBasket.initialize()
      window.o_global.eventQBus.emitModuleLoaded('ft1.order-core.minibasket');
    }
);
